module.exports = __webpack_public_path__ + "img/AL281-1.6132d504.jpg";